export interface Commodity {
    id: number;
    code: string;
    description: string;
    is_preferred: boolean;
}
